var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":require("@/assets/images/404.png"),"alt":""}}),_c('div',{staticClass:"error-cen"},[_c('div',{staticClass:"err-tip"},[_vm._v("抱歉！您访问的页面出错了")]),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }